import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { createErrorKey } from 'projects/shared/utils/getErrorMessage';
import { SelectOption } from '../../input-select/select-option';
import { FormInputComponentBase } from '../form-input-base.component';
import { InputSelectComponent } from '../../input-select/input-select.component';
import { NzSelectModeType } from 'ng-zorro-antd/select';

@Component({
  selector: 'mac-form-input-select',
  templateUrl: './form-input-select.component.html',
  standalone: false,
  styleUrls: ['../form-input-base.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: FormInputSelectComponent,
    },
  ],
})
export class FormInputSelectComponent extends FormInputComponentBase implements ControlValueAccessor {
  @Input() mode: NzSelectModeType = 'default';
  @Input() icon?: string;
  @Input() allowClear = true;
  @Input() search = false;
  @Input() applyFuzzyFilter = false;
  @Input() maxTagCount: number = Infinity;
  @Input() options: SelectOption[];

  @ViewChild('selectInput') selectInput!: ElementRef<InputSelectComponent>;

  constructor(controlContainer: ControlContainer) {
    super(controlContainer);
  }

  focus() {
    this.selectInput.nativeElement.focus();
  }

  createErrorKey(key: string): string {
    return createErrorKey(key);
  }
}
